/**
 * 平台图标
 */
const FILE_COUNT = 4; // 图片个数

const platformIconObj = {};
new Array(FILE_COUNT).fill("").forEach((item, index) => {
  platformIconObj[
    `icon-${index + 1}`
  ] = require(`../../assets/images/common/platform/icon-${index + 1}.svg`);
});

export default platformIconObj;
